module.exports = "dist/images/components-button-controls-ghost.693bd0a.png";